import React from 'react'
import 'stylesheets/Skeletons/spinner.css'
const SpinnerLoading = () => {
    return (
        <div className='spinner-loading'>
        </div>
    )
}

export default SpinnerLoading